import { formatToHumanReadable } from "@/lib/format-data";

// Growth alerts keep their OPPORTUNITY_* names on the wire; staff call them leads.
export function alertTypeLabel(alertType: string): string {
  return formatToHumanReadable(alertType.replace(/^OPPORTUNITY_/, "LEAD_"));
}
